var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPawIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    clipPath: "url(#clip0_3095_3646)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.3362 12.5397C21.423 12.5745 22.3322 11.7217 22.367 10.6349C22.4018 9.54807 21.549 8.63884 20.4622 8.60403C19.3754 8.56923 18.4662 9.42204 18.4314 10.5088C18.3966 11.5956 19.2494 12.5049 20.3362 12.5397Z",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.53649 12.5397C4.62328 12.5745 5.53252 11.7217 5.56732 10.6349C5.60213 9.54807 4.74932 8.63884 3.66252 8.60403C2.57572 8.56923 1.66649 9.42204 1.63169 10.5088C1.59688 11.5956 2.44969 12.5049 3.53649 12.5397Z",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.8342 7.24472C9.99345 7.28185 10.9633 6.37218 11.0004 5.21293C11.0375 4.05369 10.1279 3.08383 8.96864 3.04671C7.80939 3.00959 6.83953 3.91925 6.80241 5.0785C6.76529 6.23775 7.67495 7.2076 8.8342 7.24472Z",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9176 7.46738C17.0768 7.5045 18.0467 6.59484 18.0838 5.43559C18.1209 4.27634 17.2113 3.30649 16.052 3.26937C14.8928 3.23224 13.9229 4.14191 13.8858 5.30116C13.8487 6.4604 14.7583 7.43026 15.9176 7.46738Z",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1783 9.45428C11.39 9.42933 10.6149 9.66112 9.96972 10.1148C9.32454 10.5684 8.84418 11.2194 8.60096 11.9696C8.24173 13.0731 7.46084 13.9898 6.42852 14.5199C5.67961 14.8889 5.10236 15.5331 4.81748 16.3179C4.53259 17.1027 4.56213 17.9672 4.89992 18.7307C5.2377 19.4942 5.85758 20.0976 6.62993 20.4146C7.40228 20.7317 8.26729 20.7379 9.04409 20.4319C10.8481 19.7589 12.8444 19.8228 14.6017 20.6099C15.3573 20.9649 16.2209 21.0141 17.012 20.7471C17.803 20.4801 18.4602 19.9177 18.8462 19.1773C19.2321 18.437 19.3169 17.5761 19.0828 16.7747C18.8487 15.9733 18.3139 15.2935 17.5901 14.8773C16.5944 14.2821 15.8744 13.3173 15.5873 12.1934C15.3926 11.4291 14.9549 10.7487 14.3401 10.2547C13.7252 9.76073 12.9666 9.47982 12.1783 9.45428Z",
    stroke: "#1A1A1A",
    strokeWidth: 2.2,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3095_3646"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPawIcon);
export default __webpack_public_path__ + "static/media/paw-icon.7982d3c0.svg";
export { ForwardRef as ReactComponent };